function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { BehaviorSubject, combineLatest, forkJoin } from "rxjs";
import { map, tap } from "rxjs/operators";
import { ExchangeSymbolType } from "trade_utils_lib";
import { FuturePerpetualSymbolProvider } from "./FuturePerpetualSymbolProvider";
import { EmptyExchangeSymbolData } from "./interfaces";
import { SpotSymbolProvider } from "./SpotSymbolProvider";
import { SwapBinanceSymbolProvider } from "./SwapBinanceSymbolProvider";
import { SymbolMap } from "./SymbolMap";
var SymbolDataProvider = /*#__PURE__*/function () {
  function SymbolDataProvider() {
    _classCallCheck(this, SymbolDataProvider);
    _defineProperty(this, "subject", new BehaviorSubject(EmptyExchangeSymbolData));
    _defineProperty(this, "config", void 0);
    _defineProperty(this, "spot", new SpotSymbolProvider("key_exchange_symbol_cache_pionex.v2.update"));
    _defineProperty(this, "swapBinance", new SwapBinanceSymbolProvider("key_swap_binance_symbol_cache_pionex.v2"));
    _defineProperty(this, "futurePerpetual", new FuturePerpetualSymbolProvider("key_future_symbol_cache_pionex.v2"));
    _defineProperty(this, "sub", void 0);
  }
  _createClass(SymbolDataProvider, [{
    key: "getCachedSymbolData",
    value: function getCachedSymbolData() {
      return this.subject.getValue();
    }
  }, {
    key: "toExchangeSymbolData",
    value: function toExchangeSymbolData(symbolItems) {
      var initData = _objectSpread({}, EmptyExchangeSymbolData);
      symbolItems.forEach(function (e) {
        if (!e) {
          return;
        }
        initData.allSymbols = initData.allSymbols.concat(e.symbols);
        initData.symbolMap = new SymbolMap([].concat(_toConsumableArray(initData.symbolMap.entries()), _toConsumableArray(e.map.entries())));
        switch (e.symbolType) {
          case ExchangeSymbolType.spot:
            {
              initData.spotSymbolData = e;
              break;
            }
          case ExchangeSymbolType.swap_binance:
            {
              initData.swapBSymbolData = e;
              break;
            }
          case ExchangeSymbolType.future_perpetual:
            {
              initData.futurePSymbolData = e;
              break;
            }
          default:
            {
              break;
            }
        }
      });
      return initData;
    }
  }, {
    key: "_init",
    value: function _init(config) {
      var _this = this;
      this.config = config;
      var sources = [this.spot.init()];
      if (!(config !== null && config !== void 0 && config.disableSwapBinance)) {
        sources.push(this.swapBinance.init());
      }
      if (!(config !== null && config !== void 0 && config.disableFuturePerpetual)) {
        sources.push(this.futurePerpetual.init());
      }
      forkJoin(sources).pipe(map(function (data) {
        return _this.toExchangeSymbolData(data);
      })).subscribe(function (data) {
        SymbolDataProvider.shared.subject.next(data);
        _this._start();
      }, function (error) {
        console.log("SymbolDataProvider: error --- ".concat(error));
      });
    }
  }, {
    key: "_stop",
    value: function _stop() {
      var _this$sub;
      (_this$sub = this.sub) === null || _this$sub === void 0 ? void 0 : _this$sub.unsubscribe();
    }
  }, {
    key: "_start",
    value: function _start() {
      var _this$config,
        _this$config2,
        _this$sub2,
        _this2 = this;
      var sources = [this.spot.register()];
      if (!((_this$config = this.config) !== null && _this$config !== void 0 && _this$config.disableSwapBinance)) {
        sources.push(this.swapBinance.register());
      }
      if (!((_this$config2 = this.config) !== null && _this$config2 !== void 0 && _this$config2.disableFuturePerpetual)) {
        sources.push(this.futurePerpetual.register());
      }
      (_this$sub2 = this.sub) === null || _this$sub2 === void 0 ? void 0 : _this$sub2.unsubscribe();
      this.sub = combineLatest(sources).pipe(tap(function (res) {
        var data = _this2.toExchangeSymbolData(res);
        _this2.subject.next(data);
      })).subscribe(function () {}, function (error) {
        console.log("SymbolDataProvider ---> ".concat(error));
      });
    }
  }, {
    key: "getSymbolDataObservable",
    value: function getSymbolDataObservable() {
      return this.subject;
    }
  }, {
    key: "getSymbolData",
    value: function getSymbolData() {
      return this.subject.getValue();
    }
  }, {
    key: "getSymbol",
    value: function getSymbol(symbol) {
      return this.getCachedSymbolData().symbolMap.get(symbol);
    }
  }], [{
    key: "init",
    value: function init(config) {
      SymbolDataProvider.shared._init(config);
    }
  }, {
    key: "start",
    value: function start() {
      SymbolDataProvider.shared._start();
    }
  }, {
    key: "stop",
    value: function stop() {
      SymbolDataProvider.shared._stop();
    }
  }, {
    key: "getSymbol",
    value: function getSymbol(symbol) {
      return SymbolDataProvider.shared.getSymbol(symbol);
    }
  }, {
    key: "getSymbolDataObservable",
    value: function getSymbolDataObservable() {
      return SymbolDataProvider.shared.getSymbolDataObservable();
    }
  }, {
    key: "getSymbolData",
    value: function getSymbolData() {
      return SymbolDataProvider.shared.getSymbolData();
    }
  }]);
  return SymbolDataProvider;
}();
_defineProperty(SymbolDataProvider, "shared", new SymbolDataProvider());
export { SymbolDataProvider as default };